module.exports = __webpack_public_path__ + "img/rm-lt-02.3d78247d.webp";